import { Theme } from '@material-ui/core/styles'
import { createStyles, makeStyles } from '@material-ui/core/styles'
import { siteColors } from './SiteColors'

const Styles = makeStyles((theme: Theme) => createStyles({
    paper: {
        paddingTop: 40,
        paddingBottom: 40
    },
    emailBold: {
        fontWeight: 'bold',
        display: 'inline-block',
        margin: 0
    },
    infoCenter: {
        lineHeight: 1.7,
        fontSize: 14,
        fontWeight: 400,
        alignItems: 'center',
        justifyContent: 'center',
        color: siteColors.darkGray,
        textAlign: 'center'
    },
    info: {
        lineHeight: 1.7,
        fontSize: 14,
        fontWeight: 400,
        alignItems: 'center',
        justifyContent: 'center',
        color: siteColors.darkGray,
        textAlign: 'left'
    },
    companyName: {
        fontSize: 26,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: siteColors.darkGray,
        textAlign: 'center',
        fontWeight: 'bold',
        padding: 0,
        margin:0
    },
    inputBox: {
        marginTop: 20
    },
    sameLineLink: {
        display: 'inline',
        marginRight: 10
    },
    sameLineLinkPipe: {
        display: 'inline',
        marginRight: 10,
        borderLeft: 'solid 1px black'
    },
    linkBox: {
        paddingTop: 25,
        textAlign: 'center'
    },
    logoContainer: {
        textAlign: 'center',
        marginBottom: 30
    },
    input: {
        borderColor: siteColors.lighterGray,
        borderStyle: 'solid',
        borderWidth: '1px',
        borderRadius: '4px',
        background: siteColors.white,
        '& :hover': {
            background: siteColors.white,
            borderRadius: '4px',
        },
        '& :focus': {
            background: siteColors.white,
            borderRadius: '4px',
        },
        '& :focus > div': {
            background: siteColors.white,
            borderRadius: '4px',
        }
    },
    button: {
        textTransform: 'uppercase',
        padding: '15px',
        fontWeight: 600,
    },
    inputError: {
        borderColor: siteColors.darkRed,
        borderWidth: '1px',
        borderStyle: 'solid',
        borderRadius: '4px',
        background: siteColors.white,
        '& :focus': {
            background: siteColors.white,
            borderRadius: '4px',
        },
        '& :hover': {
            background: siteColors.white,
            borderRadius: '4px',
        },
        '& :focus > div': {
            background: siteColors.white,
            borderRadius: '4px',
        }
    },
    link: {
        background: 'transparent',
        textTransform: 'uppercase',
        fontWeight: 600,
        cursor: 'pointer',
        textAlign: 'center',
        fontSize: 11,
        color: siteColors.darkBlue,
        textDecoration: 'none'

    }
}));

export default Styles;